import { Viewer } from "@shared";
import style from "./PreviewAvatarSection.module.scss";
import { createPlayerSettings } from "../../utils/shared";
import { IRootState } from "../../redux/store";
import { useSelector } from "react-redux";

interface Props {
    handleDeployAvatar: () => void;
}

const PreviewAvatarSection: React.FC<Props> = ({handleDeployAvatar}) => {
	const formData = useSelector((state: IRootState) => state.avatarForm);
	const brainId = useSelector((state: IRootState) => state.avatar.brainId);

    return (
        <div className={style.avatarPreviewContainer}>
			<div className={style.avatarPreviewHeader}>
				<div className={style.previewDescriptionText}>
					<h3 className={style.previewDescriptionTitle}>Вот как ваш аватар будет выглядеть на экране клиента</h3>
					<p>Проверьте сцену и поведение аватара по промпту. Если что-то выглядит не так — вернитесь назад и внесите правки.</p>
				</div>
				<button
					className={style.deployButton}
					onClick={handleDeployAvatar}
				>
					Опубликовать
				</button>
			</div>
		    <div className={`${style.iframeWrapper}`}>
				<Viewer settings={createPlayerSettings(formData, brainId)} />
			</div>
		</div>
    );
};

export default PreviewAvatarSection;
